export default {
  meta: {
    title: '门店列表',
    url: '/intelligent/store',
    parentPath: ['/intelligent'],
    breadcrumbs: {
      path: ['/intelligent/store'],
      name: ['门店列表'],
    },
  },
};
